export const statusColorMapping = {
    success: 'green',
    warning: 'orange',
    danger: 'cranberry'
};
